import config from "../config/config";

const url = config.URL_AUTOLOGIN_OAT_USER_EAUTH;

const autoLoginOTAUserEAuth = async (ota, callback) => {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      uuid: ota,
    }),
  };

  try {
    if (!ota) return callback(null)
    return  fetch(url, requestOptions).then(async (response) => {
        
      if (response.status === 500) callback({code: response.status, status: "ERROR"});

      const data = await response.json();
    
      if (response.status !== 302) return callback({code: data?.code , status: data?.status});
      return callback(data);
    });
  } catch (error) {
    return callback({status: 'ERROR'});
  }
};

export default autoLoginOTAUserEAuth;
